import {getDuration} from "@/components/archive/utils"

const DatesPreview = ({
  lastTimestamp,
}: {
  createdAt?: string
  lastTimestamp: string
}) => {
  // Format date to be more readable
  const formattedDate = new Date(lastTimestamp).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })

  return (
    <div className="flex items-center text-xs text-gray-500">
      <span className="mr-1 font-medium">Last activity:</span>
      <span>{formattedDate}</span>
    </div>
  )
}

export default DatesPreview
